import React from "react"
import { Card, Form } from "react-bootstrap"

const GeneralHourly = ({ hours, value, onChange }) => {
  return (
    <div>
      <Card.Text as='h6'><strong>Select Hours</strong></Card.Text>
    <Card className="text-center">
      <Card.Body>
          <Card.Title as='h4'>
          <Form.Control as="select" required  value={value}
          onChange={onChange}
          >{
            hours.map((x,index)=>(
                <option key={index} data-hourid={x.id}  value={x.Hours} data-hour-zoneid={x.zone}>
                  {x.Hours}
                </option>
              ))
            }
          </Form.Control> 
          </Card.Title>
      </Card.Body>
    </Card>
    </div>
  )
}

export default GeneralHourly
